// extracted by mini-css-extract-plugin
export default {"OpenPOS":"styles_OpenPOS__RgGg6","sen":"styles_sen__USKFj","senior":"styles_senior__DGV5F","remote":"styles_remote__JX9rK"};